import {CssBaseline} from '@mui/material';
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';
import {GuardianComponent} from './pages/GuardianComponent';
import {StartIdentifyScam} from './pages/StartIdentifyScam';
import {ScenariosListPage} from './pages/Admin/ScenariosListPage';
import {AdminLayout} from './components/Admins/AdminLayout';
import {MainPage} from './pages/mainPage';
import {ScenariosNodeListPage} from './pages/Admin/ScenariosNodeListPage';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {LandingPage} from './components/LadingPages/LandingPage';
import {AppTutorialManager1} from "./components/Tutorials/TutorialOverlays/AppTutorialManager1";
import {AppTutorialResponsiveSwitcher} from "./components/Tutorials/TutorialOverlays/AppTutorialResponsiveSwitcher";

function App() {
    return (<>
            <BrowserRouter>
                <CssBaseline/>
                <AppTutorialResponsiveSwitcher/>
                {/*<LanguageSwitcher/>*/}
                {/*<AppTutorialManager1/>*/}
                <Routes>
                    <Route path="/" element={<MainPage/>}>
                        <Route index element={<Navigate to="choose-guardian" replace/>}/>
                        <Route path="Home" element={<GuardianComponent/>}/>
                        <Route path="StartIdentifyScam" element={<StartIdentifyScam/>}/>
                        <Route path="choose-guardian" element={<GuardianComponent/>}/>

                        {/* Landing pages */}
                        <Route
                            path="archives"
                            element={
                                <LandingPage/>
                            }
                        />
                        <Route
                            path="anti-scam-defenders"
                            element={
                                <LandingPage/>
                            }
                        />
                        <Route
                            path="contribution-community"
                            element={
                                <LandingPage/>
                            }
                        />
                        <Route
                            path="scam-education"
                            element={
                                <LandingPage/>
                            }
                        />
                    </Route>

                    <Route path="/admin" element={<AdminLayout/>}>
                        <Route path="ScenariosList" element={<ScenariosListPage/>}/>
                        <Route path="ScenariosNodeList" element={<ScenariosNodeListPage/>}/>
                    </Route>
                </Routes>
            </BrowserRouter>
        </>
    );
}

export default App;
